import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'APM_LOCATION_INFO',
    itemActionName: 'APM_LOCATION_INFO_ITEM',
});
